import { useContext, useEffect, useState } from 'react';
import { TabItem } from './TabItem';
import { SlideViewerContext } from '../../slideviewer/SlideViewerContextProvider';

export default function Tabs({
  containerClassName,
  footerContainerClassName,
  footerExtra: FooterExtra,
  items,
  labelClassName,
  labelClassNameActive,
  labelsContainerClassName,
}) {
  const { isTeacher } = useContext(SlideViewerContext);
  const defaultTab = isTeacher ? 0 : 1;
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    // because sometimes items will be removed from the tabs & then we want to show something not broken
    if (activeTab > items.length - 1) {
      setActiveTab(defaultTab);
    }
  }, [activeTab, defaultTab, items, setActiveTab]);

  return (
    <div className={containerClassName}>
      {items && items[activeTab].show && items[activeTab]?.content}
      <div className={footerContainerClassName}>
        <div className={labelsContainerClassName}>
          {items &&
            items.map((item, index) => (
              <TabItem
                key={`tab_${item.button.id}`}
                className={
                  index === activeTab ? labelClassNameActive : labelClassName
                }
                item={item}
                setActiveTab={setActiveTab}
                tabIndex={index}
              />
            ))}
        </div>
        {FooterExtra}
      </div>
    </div>
  );
}
